import React from 'react'
import { useController, useFormContext } from 'react-hook-form'
import styled from 'styled-components'
import get from 'lodash.get'

import { ErrorMessage } from '@hookform/error-message'
import Input from './Input'
import errorIcon from 'assets/svg/error.svg'
import { ValidationError } from 'components/ValidationError'
import ReactTooltip from 'react-tooltip'

const ErrorIcon = styled.img.attrs({ alt: '', src: errorIcon })`
    width: 20px;
    height: 20px;
    margin-left: 5px;
`

const SpanTooltip = styled.span`
    text-align: center;
    display: flex;
    justify-content: center;
`

const makeTooltipContent = (dataTip) => (
    <SpanTooltip dangerouslySetInnerHTML={{ __html: dataTip }} />
)

const InputField = ({
    as = Input,
    defaultValue = '',
    tooltipErrors,
    errorColor,
    control,
    name,
    errors,
    maxValue,
    rules,
    children,
    onChange,
    onBlur,
    ...otherProps
}) => {
    const {
        field: {
            ref,
            onChange: onChangeForm,
            onBlur: onBlurForm,
            ...otherFields
        }
    } = useController({
        control,
        name,
        rules,
        defaultValue
    })

    const { formState } = useFormContext()

    const handleBlur = (event) => {
        onBlurForm()
        onBlur(event)
    }

    const handleChange = (value) => {
        if (maxValue && value > maxValue) {
            value = maxValue
        }

        onChangeForm(value)
        onChange(value)
    }

    const Component = as
    const errorMessage = get({ ...formState.errors, ...errors }, name)?.message

    return (
        <>
            <Component
                ref={ref}
                {...otherProps}
                {...otherFields}
                errorColor={errorColor}
                hasError={!!errorMessage}
                data-multiline="true"
                data-place="bottom"
                data-tip={tooltipErrors && errorMessage}
                data-for={tooltipErrors && name}
                onBlur={handleBlur}
                onChange={handleChange}
            >
                {children}
                <ErrorMessage
                    errors={errors}
                    name={name}
                    render={() => <ErrorIcon />}
                />
            </Component>
            {tooltipErrors && !!errorMessage ? (
                <ReactTooltip
                    effect="solid"
                    place="bottom"
                    id={name}
                    getContent={makeTooltipContent}
                />
            ) : (
                <ErrorMessage
                    errors={errors}
                    name={name}
                    render={({ message }) => (
                        <ValidationError>{message}</ValidationError>
                    )}
                />
            )}
            {}
        </>
    )
}

InputField.defaultProps = {
    onChange: () => {},
    onBlur: () => {}
}

export default InputField
